import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'brand',
  colors: {
    brand: [
      '#E8F6FD',
      '#D4EEFA',
      '#C0E6F7',
      '#97D7EF',
      '#65C4E6',
      '#26A5DF',
      '#1E8FC4',
      '#197AA8',
      '#145F82',
      '#0E425B',
    ],
  },
  defaultRadius: 'md',
  fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '600',
  },
});
